const HEIC_MIME_TYPES = new Set([
  'image/heic',
  'image/heif',
  'image/heic-sequence',
  'image/heif-sequence'
]);

const HEIC_EXTENSIONS = ['.heic', '.heif'];

const EXTENSION_TO_MIME = {
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.gif': 'image/gif',
  '.webp': 'image/webp',
  '.heic': 'image/heic',
  '.heif': 'image/heif',
  '.pdf': 'application/pdf',
};

const isHeicByName = (fileName = '') => {
  const lowerName = fileName.toLowerCase();
  return HEIC_EXTENSIONS.some((extension) => lowerName.endsWith(extension));
};

// Windows browsers don't recognize HEIC and return empty file.type, so we fall back to extension
const resolveFileMimeType = (file) => {
  if (file?.type) return file.type;
  const name = (file?.name || '').toLowerCase();
  const dotIndex = name.lastIndexOf('.');
  if (dotIndex === -1) return 'application/octet-stream';
  const ext = name.slice(dotIndex);
  return EXTENSION_TO_MIME[ext] || 'application/octet-stream';
};

const isHeicLikeFile = (file) => {
  if (!file) return false;
  if (HEIC_MIME_TYPES.has(file.type)) return true;
  return isHeicByName(file.name);
};

const toSingleBlob = (conversionResult) => {
  if (Array.isArray(conversionResult)) {
    return conversionResult[0];
  }
  return conversionResult;
};

const convertHeicToJpegBlob = async (file) => {
  const { default: heic2any } = await import('heic2any');
  const conversionResult = await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.9
  });
  return toSingleBlob(conversionResult);
};

const getPreviewUrlForFile = async (file) => {
  if (!isHeicLikeFile(file)) {
    return URL.createObjectURL(file);
  }
  try {
    const jpegBlob = await convertHeicToJpegBlob(file);
    return URL.createObjectURL(jpegBlob);
  } catch (error) {
    console.error('Failed to convert HEIC/HEIF preview:', error);
    return URL.createObjectURL(file);
  }
};

// backend already converts HEIC to JPEG on S3, so presigned URLs serve browser-readable content
const getPreviewUrlForStoredImage = async ({ url }) => {
  if (!url) return '';
  return url;
};

export {
  getPreviewUrlForFile,
  getPreviewUrlForStoredImage,
  resolveFileMimeType
};
